import { SectionTitle } from './SectionTitle';

const FEATURES = [
  { icon: 'icon-flame', title: 'Anima Mastery', text: 'Sistema completo de evolução de Anima — treinar, resetar, transcender e comercializar.' },
  { icon: 'icon-chest', title: 'Auto Loot', text: 'Recolhe os itens do chão automaticamente, sem precisar parar de combater.' },
  { icon: 'icon-scroll', title: 'Auto Quest', text: 'Diálogos de missões completados automaticamente, sem apertar espaço.' },
  { icon: 'icon-swords', title: 'Macro BM3', text: 'Combos e rotação automática de skills, totalmente customizáveis.' },
  { icon: 'icon-mask', title: 'Armário de Fantasia', text: 'Armazene, organize e alterne entre seus costumes em páginas dedicadas.' },
  { icon: 'icon-gear', title: 'Predefinições', text: 'Crie predefinições de equipamento e troque de build com um clique.' },
  { icon: 'icon-gate', title: 'Dungeon System', text: 'Dungeons progressivas com rotas otimizadas e grandes recompensas.' },
  { icon: 'icon-horn', title: 'Anúncio de Loot', text: 'Drops raros do servidor anunciados em tempo real para todos.' },
];

export function SystemsSection() {
  return (
    <section className="section systems" id="diferenciais">
      <div className="shell">
        <SectionTitle title="Sistemas & Diferenciais" subtitle="Tudo que faz o Cabal Liberty ser único, pensado para uma experiência completa." />
        <div className="systems-grid fantasy-frame reveal">
          {FEATURES.map((f) => (
            <article key={f.title} className="feature">
              <div className="icon"><img src={`/assets/liberty/ui/${f.icon}.svg`} alt="" /></div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
